/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {useNavigate} from 'react-router-dom'
import Chart from 'react-apexcharts'
import {GET, POST} from '../../../../services/api'
import {Input} from '../../../../components/Input/Input'
import {Button} from '../../../../components/Button/Button'
import {Loading} from '../../../../components/Loading/Loading'
import {i18n} from '../../../../translate/i18n'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'

const CustosContent: FC = () => {
  const navigate = useNavigate()
  const [startDate, setStartDate] = useState('')
  const [finalDate, setFinalDate] = useState('')
  const periodo = [
    {
      name: '1 Semana',
      id: 0,
    },
    {
      name: '1 Mês',
      id: 1,
    },
    {
      name: '3 Meses',
      id: 2,
    },
  ]
  const [periodoSelected, setPeriodoSelected] = useState<any>('0')

  const [loading, setLoading] = useState(false)
  const [somaCusto, setSomaCusto] = useState<any>([])
  const [meses, setMeses] = useState<any>([])
  const [produtosMes, setProdutosMes] = useState<any>([])

  const allGroupBar = async (obj: any) => {
    try {
      const uniqueYearMonths = Array.from(
        new Set(
          obj.map((item: any) => {
            const [year, month] = item.dataCarga.split('T')[0].split('-')

            const date = new Date(`${year}-${month}-01T23:59:59Z`)

            const monthName = date.toLocaleDateString('pt-BR', {month: 'long'})

            return `${monthName.charAt(0).toUpperCase() + monthName.slice(1)} de ${year}`
          })
        )
      )
      setMeses(uniqueYearMonths)

      const dadosPorMes = obj.reduce((acc: any, item: any) => {
        const [year, month] = item.dataCarga.split('T')[0].split('-')

        const data = new Date(`${year}-${month}-01T00:00:00Z`)
        const mes = data.getUTCMonth() + 1
        if (!acc[mes]) {
          acc[mes] = []
        }
        acc[mes].push(item)
        return acc
      }, {})

      const newDadosPorMes = Object.values(dadosPorMes)
      const promises = newDadosPorMes.map((dadoMes) => allGroup(dadoMes))
      const results = await Promise.all(promises)

      let visualizacao: any = []
      let armazenamento: any = []
      let logs: any = []

      results.forEach((mes: any) => {
        mes.map((coluna: any) => {
          if (coluna.label === 'Visualização') visualizacao.push(coluna.custo)
          if (coluna.label === 'Armazenamento') armazenamento.push(coluna.custo)
          if (coluna.label === 'Logs') logs.push(coluna.custo)
        })
      })

      setProdutosMes([
        {
          name: 'Visualização',
          data: visualizacao,
        },
        {
          name: 'Armazenamento',
          data: armazenamento,
        },
        {
          name: 'Logs',
          data: logs,
        },
      ])
    } catch (error) {
      console.log(error)
    }
  }

  const allGroup = async (obj: any) => {
    try {
      const newGroup = obj.reduce((acc: any, coluna: any) => {
        if (coluna.label.includes('search') || coluna.label.includes('seach')) {
          if (!acc['visualizacao']) {
            acc['visualizacao'] = {label: 'Visualização', custo: 0, dataCarga: coluna.dataCarga}
          }
          acc['visualizacao'].custo += parseFloat(coluna.custo)
        } else if (
          coluna.label.includes('charge') ||
          coluna.label.includes('Charge') ||
          coluna.label.includes('gridItem')
        ) {
          if (!acc['armazenamento']) {
            acc['armazenamento'] = {label: 'Armazenamento', custo: 0, dataCarga: coluna.dataCarga}
          }
          acc['armazenamento'].custo += parseFloat(coluna.custo)
        } else {
          if (!acc['logs']) {
            acc['logs'] = {label: 'Logs', custo: 0, dataCarga: coluna.dataCarga}
          }
          acc['logs'].custo += parseFloat(coluna.custo)
        }

        return acc
      }, {})

      return Object.values(newGroup)
    } catch (error) {
      console.log(error)
    }
  }

  const getItemsFiltered = async () => {
    try {
      setLoading(true)

      let today = finalDate
      let endDate = startDate

      console.log(startDate, finalDate)

      if (periodoSelected) {
        today = new Date().toISOString().split('T')[0]
        switch (periodoSelected) {
          case '0':
            {
              // Subtrair 1 semana
              const data = new Date(today)
              data.setDate(data.getDate() - 7)
              endDate = data.toISOString().split('T')[0]
            }
            break

          case '1':
            {
              // Subtrair 1 Mês
              const data = new Date(today)
              data.setMonth(data.getMonth() - 1)
              endDate = data.toISOString().split('T')[0]
            }
            break

          case '2':
            {
              // Subtrair 3 Mês
              const data = new Date(today)
              data.setMonth(data.getMonth() - 3)
              endDate = data.toISOString().split('T')[0]
            }
            break

          default:
            // Caso o período não seja 0, 1 ou 2
            endDate = today // Mantém a data atual
            break
        }
      }

      const dataRes = await POST('cargo-counter/filter', {})
      const newDataRes = dataRes.data
        .filter(
          (custo: any) =>
            custo.totalItens > 0 &&
            Date.parse(custo.dataCarga) >= Date.parse(endDate) &&
            Date.parse(custo.dataCarga) <= Date.parse(today)
        )
        .map((custo: any) => ({
          label: custo.method,
          custo: Number(custo.summary),
          dataCarga: custo.dataCarga,
        }))
      const all = await allGroup(newDataRes)
      allGroupBar(newDataRes)
      setSomaCusto(all)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    } finally {
      setPeriodoSelected(null)
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12 w-100'>
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.cost`)}
                  </span>
                  <BreadCrumbs />
                </h3>
              </div>
              <div className='card-body'>
                <div>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bolder fs-3 mb-1'>
                      {i18n.t(`indicators.filters`)}
                    </span>
                  </h3>
                </div>
                <div className='d-flex gap-5 flex-wrap'>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    placeholder='Selecione um tipo'
                    label={i18n.t(`indicators.period`)}
                    options={periodo.map((periodo: any) => ({
                      select: periodo.name,
                      value: periodo.id,
                    }))}
                    value={periodoSelected}
                    change={(value: string) => setPeriodoSelected(value)}
                  />
                  <Input
                    inputAttr={{
                      type: 'date',
                    }}
                    label={i18n.t(`indicators.first`)}
                    value={startDate}
                    change={(value: string) => setStartDate(value)}
                  />
                  <Input
                    inputAttr={{
                      type: 'date',
                    }}
                    label={i18n.t(`indicators.end`)}
                    value={finalDate}
                    change={(value: string) => setFinalDate(value)}
                  />
                  <div className='d-flex align-items-end'>
                    <Button
                      text={i18n.t(`buttons.filter`)}
                      color='primary'
                      size='small'
                      btnAttr={{
                        type: 'button',
                      }}
                      click={getItemsFiltered}
                      btnClass='fw-bolder mb-1'
                      verticalPadding={3}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between flex-wrap gap-5'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12 col-12 col-lg-6'>
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.summaryTypeCust`)}
                  </span>
                </h3>
              </div>
              <div className='card-body'>
                {somaCusto.length > 0 ? (
                  <Chart
                    options={{
                      labels: somaCusto.map((custo: any) => custo.label),
                      dataLabels: {
                        enabled: false,
                      },
                      tooltip: {
                        y: {
                          formatter: (val: number) => {
                            const total = somaCusto.reduce(
                              (acc: number, custo: any) => acc + custo.custo,
                              0
                            )
                            const percentage = ((val / total) * 100).toFixed(1)
                            return `${new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).format(val)} (${percentage}%)`
                          },
                        },
                      },
                      legend: {
                        position: 'right',
                        formatter: function (seriesName: string, opts: any) {
                          const total = somaCusto.reduce(
                            (acc: number, custo: any) => acc + custo.custo,
                            0
                          )
                          const percentage = (
                            (opts.w.globals.series[opts.seriesIndex] / total) *
                            100
                          ).toFixed(1)
                          return `${seriesName}: ${new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          }).format(opts.w.globals.series[opts.seriesIndex])} (${percentage}%)`
                        },
                      },
                    }}
                    series={somaCusto.map((custo: any) => custo.custo)}
                    type='pie'
                    height={220}
                  />
                ) : (
                  <div style={{textAlign: 'center', marginTop: '20px'}}>
                    <p>Nenhum dado disponível para gerar o gráfico.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between flex-wrap gap-5'>
            <div
              className='card card-xxl-stretch mb-5 mb-xl-12'
              style={{flex: '1', minWidth: '20em'}}
            >
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.summaryComposition`)}
                  </span>
                </h3>
              </div>
              <div className='card-body'>
                {produtosMes.length > 0 ? (
                  <Chart
                    options={{
                      chart: {
                        type: 'bar',
                        stacked: true,
                      },
                      xaxis: {
                        categories: meses.map((mes: any) => mes),
                      },
                      yaxis: {
                        labels: {
                          formatter: (val: number) => {
                            return new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).format(val)
                          },
                        },
                      },
                      dataLabels: {
                        enabled: true,
                        formatter: (val: number) => {
                          return new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          }).format(val)
                        },
                      },
                      legend: {
                        position: 'top',
                      },
                    }}
                    series={produtosMes}
                    type='bar'
                    height={220}
                  />
                ) : (
                  <div style={{textAlign: 'center', marginTop: '20px'}}>
                    <p>Nenhum dado disponível para gerar o gráfico.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          {produtosMes &&
            produtosMes.map((type: any, index: number) => (
              <div key={index} className='d-flex justify-content-between flex-wrap gap-5'>
                <div
                  className='card card-xxl-stretch mb-5 mb-xl-12'
                  style={{flex: '1', minWidth: '20em'}}
                >
                  <div className='card-header'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bolder fs-3 mb-1'>{type.name}</span>
                    </h3>
                  </div>
                  <div className='card-body'>
                    <Chart
                      options={{
                        chart: {
                          type: 'bar',
                          stacked: true,
                        },
                        xaxis: {
                          categories: meses.map((mes: any) => mes),
                        },
                        yaxis: {
                          labels: {
                            formatter: (val: number) => {
                              return new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                                minimumFractionDigits: 4,
                              }).format(val)
                            },
                          },
                        },
                        dataLabels: {
                          enabled: true,
                          formatter: (val: number) => {
                            return new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                              minimumFractionDigits: 4, // Exibe 4 casas decimais
                            }).format(val)
                          },
                        },
                        legend: {
                          position: 'top',
                        },
                      }}
                      series={[{name: type.name, data: type.data}]}
                      type='bar'
                      height={220}
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}
    </>
  )
}

const CustosIndicadores: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`indicators.cost`), path: 'indicadores/chargecost', isActive: true},
        ]}
      >
        {i18n.t(`indicators.cost`)}
      </PageTitle>
      <CustosContent />
    </>
  )
}

export {CustosIndicadores}
